
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import useScreenWidth from "../../../hooks/useScreenwidth";
import { CircularProgress } from "@mui/material";
import { faIR } from "@mui/x-date-pickers/locales";

const CustomDatagrid = ({
  rows,
  columns,
  CustomNoRowsOverlay,
  getRowId,
  height,
  tHeight = '22rem',
  checkRequired = false,
  onCellClick,
  canEdit,
  hoverColor = "#F5F8FA",
  onRowClick,
  isLoadingStateProvided,
  isLoading,
}) => {

  const [showLoader, setShowLoader] = useState(true);
  const screenWidth = useScreenWidth();
  const [isRowsVisible, setIsRowsVisible] = useState(false)

  useEffect(() => {
    if (isLoadingStateProvided) {
      setShowLoader(isLoading);
    }
  }, [isLoading]);

  const dynamicHeight = rows?.length > 0
    ? "auto"
    : screenWidth > 1600
    ? "90vh"
    : tHeight;

  const modifiedColumns = columns?.map((column) => ({
    ...column,
    sortable: column?.hasOwnProperty("sortable") ? column.sortable : false,
  }));

  return (
    <Box
      sx={{
        minHeight: tHeight,
        marginBottom: "1.5rem",
        transition: "height 0.3s ease-in-out",
        height: dynamicHeight,
        fontFamily: "Inter, sans-serif",
        "& .MuiDataGrid-root": {
          border: "none",
          backgroundColor: "#ffffff",
        },
      }}
    >
      <div
        className={`${isRowsVisible ? "" : "table-div"} h-100 mb-3`}
        style={{ height: isRowsVisible ? "100%" : "0" }}
      >
        <DataGrid
          rows={rows}
          columns={modifiedColumns}
          getRowId={getRowId}
          initialState={{
            pagination: {
              paginationModel: { pageSize: 100 },
            },
          }}
          loading={showLoader}
          onCellClick={onCellClick}
          checkboxSelection={checkRequired}
          getRowHeight={height}
          disableRowSelectionOnClick
          hideFooterPagination={false}
          hideFooter
          disableColumnMenu
          className="custom-scrollbar"
          sx={{
            "&.MuiDataGrid-root": {
              border: "none",
              fontFamily: "Nunito Sans, sans-serif",
            },
            "& .MuiDataGrid-cell": {
              // borderBottom: "1px solid #E5E7EB",
              padding: "12px 16px",
              color: "#111827",
              fontSize: "14px",
              display: "flex",
              cursor: (params) => params.field !== "actions" && canEdit ? "pointer" : "default",
              alignItems: "center", // Vertically centers content
              "&:focus, &:focus-within": {
                outline: "none",
              },
            },
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: "#FCFCFC",
              borderBottom: "1px solid #E5E7EB",
            },
            "& .MuiDataGrid-columnHeader": {
              backgroundColor: "#FCFCFC",
              padding: "14px 16px",
              height: "48px !important",
              fontWeight: "800",
              fontSize: "14px",
              color: "#121212",

              textTransform: "uppercase",
              letterSpacing: "0.02em",
              "&:focus, &:focus-within": {
                outline: "none",
              },
            },
            "& .MuiDataGrid-columnHeaderTitle": {
              fontWeight: "700",
              fontColor: "#f4f4f4",
            },
            "& .MuiDataGrid-row": {
              transition: "background 0.2s ease-in-out",
              "&:hover": {
                backgroundColor: hoverColor,
                borderRadius: "0px", // Removes any border-radius
              },
            },
            "& .MuiCheckbox-root": {
              color: "#9CA3AF !important",
              "&.Mui-checked": {
                color: "#2563EB !important",
              },
            },
            "& .MuiDataGrid-virtualScroller": {
              "&::-webkit-scrollbar": {
                display: "none",
              },
              "-ms-overflow-style": "none" /* IE and Edge */,
              "scrollbar-width": "none" /* Firefox */,
            },
            "& .MuiDataGrid-scrollbar": {
              display: "none !important",
            },
            "& .MuiDataGrid-filler": {
              display: "none !important",
            },
            overflowX: "hidden",
            overflowY: "hidden",
          }}
          slots={{
            noRowsOverlay: CustomNoRowsOverlay,
            loadingOverlay: () => (
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              height: "100%",
                            }}
                          >
                            <CircularProgress
                              sx={{ color: "#6C5DD3", marginBottom: "1rem" }}
                              size={40}
                            />
                          </Box>
                        ),
          }}
          disableColumnFilter
        />
      </div>
    </Box>
  );
};

export default CustomDatagrid;
